import { queryOptions } from '@tanstack/react-query';

import { taskCommentsApi } from './api-handlers';
import { taskCommentsQueryKeys } from './query-keys';

export const taskCommentsQueryOptions = {
    getTaskCommentsQueryOptions: (taskId: string) =>
        queryOptions({
            queryKey: taskCommentsQueryKeys.list(taskId),
            queryFn: ({ signal }) => taskCommentsApi.getTaskComments(taskId, signal),
            refetchOnWindowFocus: false,
        }),
};
